/** Stacking order of floating layers. Popovers sit above dialogs so a menu opened inside a dialog is visible. */
export const DIALOG_Z_INDEX = 1000;
export const POPOVER_Z_INDEX = 1100;
export const TOAST_Z_INDEX = 1200;
